import React, { useState } from "react";
import ConsumerTableComponent from "./consumerTable.component";
import { useSelector } from "react-redux";

export default function ConsumerTableContainer({
  consumers,
  customField,
  isFetching,
  page,
  search,
  rowsPerPage,
  totalRecords,
  handleChangePage,
  handleChangeRowsPerPage,
  handleReload,
  handleEditLoyaltyPoint,
  paginationOptions,
  handleSearch,
}) {
  const isLoadingConsumerError = useSelector(
    (state) => state.consumer.isLoadingConsumerError
  );
  const lang = useSelector((state) => state.constant.languages);
  const companyId = useSelector((state) => state.profile.companyID);
  const language = useSelector((state) => state.profile.language);
  const [searchColumn, setSearchColumn] = useState(0);
  const [searchData, setSearchData] = useState("");
  const [dateRange, setDateRange] = useState(null);

  const clearSearch = () => {
    setSearchData("");
    setSearchColumn(0);
    setDateRange(null);
    handleSearch("", 0, null);
    // handleReload();
  };

  const handleSubmit = () => {
    handleSearch(searchData, searchColumn, dateRange);
  };

  return (
    <ConsumerTableComponent
      isFetching={isFetching}
      consumers={consumers}
      customField={customField}
      page={page}
      language={language}
      search={search}
      rowsPerPage={rowsPerPage}
      totalRecords={totalRecords}
      handleChangePage={handleChangePage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      handleReload={handleReload}
      isLoadingConsumerError={isLoadingConsumerError}
      paginationOptions={paginationOptions}
      handleEditLoyaltyPoint={handleEditLoyaltyPoint}
      lang={lang}
      clearSearch={clearSearch}
      searchColumn={searchColumn}
      setSearchColumn={setSearchColumn}
      searchData={searchData}
      setSearchData={setSearchData}
      handleSubmit={handleSubmit}
      companyId={companyId}
      dateRange={dateRange}
      setDateRange={setDateRange}
    />
  );
}
